import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function ContactFormModal({ open, onClose }) {
  const GOOGLE_FORM_ACTION =
    "https://docs.google.com/forms/d/e/1FAIpQLSfjTBI8Xtw6W2mBo2KGzm4rukYhMn7_O6IkSOc53Q8yyyB7QA/formResponse";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // "success" | "error" | ""

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    try {
      const form = new FormData();
      form.append("entry.494295960", formData.name);
      form.append("entry.936440329", formData.phone);
      form.append("entry.285611299", formData.email);
      form.append("entry.122087125", formData.address);
      form.append("entry.332902357", formData.message);

      await fetch(GOOGLE_FORM_ACTION, {
        method: "POST",
        mode: "no-cors", // important for Google Forms
        body: form,
      });

      setStatus("success");
      setFormData({
        name: "",
        phone: "",
        email: "",
        address: "",
        message: "",
      });
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-black"
            >
              <X size={22} />
            </button>

            <h2 className="text-2xl font-bold mb-4 text-[#E1306C]">Contact Us</h2>

            {status === "success" ? (
              <p className="text-green-600 font-medium">
                ✅ Thank you! Your response has been recorded.
              </p>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                  className="w-full border rounded-lg px-4 py-2"
                />

                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Phone Number"
                  className="w-full border rounded-lg px-4 py-2"
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Email Address"
                  className="w-full border rounded-lg px-4 py-2"
                />

                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  placeholder="Your Address"
                  className="w-full border rounded-lg px-4 py-2"
                />

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message (optional)"
                  className="w-full border rounded-lg px-4 py-2"
                />

                <button
                  type="submit"
                  className="w-full bg-[#E1306C] hover:bg-[#b32452] text-white py-2 rounded-lg font-medium transition"
                >
                  Send
                </button>
              </form>
            )}

            {status === "error" && (
              <p className="text-red-600 font-medium mt-3">
                ❌ Something went wrong. Please try again.
              </p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
